import MobileDetect from 'mobile-detect';
import muvikaAttrs from './../attrs'

const tabletExceptions = [
  'AGS\-W09',
  'AGS\-L09',
  'AGS2\-L09',
  'AGM3\-AL09HN', // Huawei Honor Pad X8
  'T1\-A21L', // Huawei MediaPad T1
  'P01T_1', // Asus ZenPad 10
  'SM\-T\d', // Any Samsung Galaxy Tab T series
  'SM\-X20\d', // Samsung Galaxy Tab X series
  'SM\-F936', // Samsung foldable phone, better think it's a tablet
  'CPN\-L09', // Huawein Mediapad M3 Lite 8
  'SmartTvA', // Vestel smart tv,
  'Lenovo TB\-J', // Lenovo tablet
  'BSL_S28_YY', // hifi tower karaoke device
  'PAR\-LX1', // Huawei PHONE but more like a tablet
  'Android \d+; K\\\)', // note the similar mobile exc that overrides this
];

const mobileExceptions = [
  'Android \d+; K\\\).*Mobile',
];

export function getOS() {
  var userAgent = window.navigator.userAgent,
    platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
    macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
    windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
    iosPlatforms = ['iPhone', 'iPad', 'iPod'],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (/Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

function checkTabletException(detector) {
  tabletExceptions.forEach((pattern) => {
    if (detector.match(pattern)) {
      console.log(pattern);
      return true;
    }
  });
  return false;
}

function checkMobileException(detector) {
  mobileExceptions.forEach((pattern) => {
    if (detector.match(pattern)) {
      console.log(pattern);
      return true;
    }
  });
  return false;
}

export function isSamsungBrowser() {
  let detector = new MobileDetect(window.navigator.userAgent);
  return detector.match("SamsungBrowser");
}

export function isDesktop() {
  let detector = new MobileDetect(window.navigator.userAgent);
  /*   if(checkTabletException(detector) || checkMobileException(detector)){
      return false;
    } */
  return !detector.mobile() && !detector.phone() && !detector.tablet();
}

export function isTablet() {
  let detector = new MobileDetect(window.navigator.userAgent);
  /*   if(checkTabletException(detector)){
      return true;
    }
    if(checkMobileException(detector)){
      return false;
    } */
  return !detector.phone() && detector.tablet() && !checkMobileException();
}

export function isPhone() {
  let detector = new MobileDetect(window.navigator.userAgent);
  /*   if(checkTabletException(detector)){
      return false;
    }
    if(checkMobileException(detector)){
      return true;
    } */
   console.log("system", detector)
  return detector.phone() && !detector.tablet();
}

export function isIPhone() {
  let detector = new MobileDetect(window.navigator.userAgent);
  return detector.phone() === "iPhone";
}

export function isPossiblyIPad() {
  let isMac = window.navigator.userAgent.includes("Mac");
  let detector = new MobileDetect(window.navigator.userAgent);
  let platform = sessionStorage.getItem(muvikaAttrs.service + "-platform");
  if (platform) {
    let platformParsed = JSON.parse(platform);
    let isMacOs = platformParsed.includes("macOS");
    if(isMacOs){
      return false;
    }
  }
  return !detector.phone() && isMac;
}

export function isChromecast() {
  return window.navigator.userAgent.includes("CrOS");
}